export default __webpack_public_path__ + "static/media/svg-1.33093397.svg";